// extracted by mini-css-extract-plugin
export default {"textInputContainer":"styles_textInputContainer__iG32-","label":"styles_label__ex+pz"};